/** Knock-compatible feed status filter values. */
export type NotificationFeedFilter = 'all' | 'unread' | 'read';

export const NOTIFICATION_FEED_FILTERS: NotificationFeedFilter[] = ['all', 'unread', 'read'];
